import Player from '@vimeo/player'; // Vimeo SDK

import axios from 'axios';
let playerInstance: any = null;

const ACCESS_TOKEN = '2882f8d876e951dfb0357c88629dcf78';
// Function to initialize Vimeo Player
export const initVimeoPlayer = async (
    vimeoPlayerRef: HTMLDivElement | null,
    videoId: string,
    startTime: number,
    endTime: number,
    muted: boolean,
    loop: boolean,
    width: number,
    height: number,
    onEnd: () => void
) => {
    if (!playerInstance && vimeoPlayerRef) {
        playerInstance = new Player(vimeoPlayerRef, {
            id: parseInt(videoId),
            autoplay: true,
            loop: loop,
            muted: muted,
            width,
            height,
            controls: false,
        });

        playerInstance.ready().then(() => {
            playerInstance.setCurrentTime(startTime).then(() => {
                playerInstance.play();
            });

            playerInstance.on('timeupdate', (data: any) => {
                if (data.seconds >= endTime) {
                    if (loop) {
                        restartAutoplay(startTime);
                    } else {
                        onEnd();
                    }
                }
            });
        }).catch((error: any) => {
            console.error('Player is not ready:', error);
        });
    }
};

// Function to restart autoplay
export const restartAutoplay = (startTime: number) => {
    if (playerInstance) {
        playerInstance.setCurrentTime(startTime).then(() => {
            playerInstance.play();
        });
    }
};

// Function to update player settings (mute/loop)
export const updatePlayerSettings = (muted: boolean, loop: boolean) => {
    if (playerInstance) {
        playerInstance.setMuted(muted);
        playerInstance.setLoop(loop);
    }
};

// Function to clean up player instance
export const destroyPlayer = () => {
    if (playerInstance) {
        playerInstance.destroy();
        playerInstance = null;
    }
};

export const getVimeoVideoId = (url: string) => {
    const regex = /vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)(?:$|\/|\?)/;
    const match = regex.exec(url);
    return match ? match[1] : null;
};

// Fetch video details from Vimeo API
export const fetchVimeoVideoData = async (videoUrl: string) => {
    const videoId = getVimeoVideoId(videoUrl);
    if (!videoId) {
        throw new Error('Invalid Vimeo URL');
    }

    const response = await axios.get(`https://api.vimeo.com/videos/${videoId}`, {
        headers: {
            Authorization: `Bearer ${ACCESS_TOKEN}`,
        },
    });

    return response.data;
};

// Generate Vimeo embed URL
export const getVimeoEmbedUrl = (videoId: string) => {
    return `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&title=0&controls=0`;
};